import React, { useState, useEffect } from 'react';
import {
    Button,
    FormControl,
    Grid,

    MenuItem,
    Popover,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField
} from '@mui/material';
import { useForm } from "react-hook-form";
import {apiUsers} from '../../services/api/users/User';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from "react-i18next";
import SortableTableCell from "../table/SortableTableCell";

const UsersComponent = (props) => {
    const [items, setItems] = useState([]);
    const [validationMessage, setValidationMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [id, setIdValue] = useState(-1);
    const [openGrant, setOpenGrant] = useState(false);
    const [grantUserId, setGrantUserId] = useState(-1);
    const [grantIsYear, setGrantIsYear] = useState(false);
    const [isGrantLoading, setIsGrantLoading] = useState(false);
    const { register,  getValues, setValue } = useForm();
    const [sortIndex, setSortIndex] = useState(-1);
    const [sortName, setSortName] = useState('');
    const [hover, setHover] = useState(-1);
    const [sortOrder, setSortOrder] = useState('asc');
    const [page, setPage] = useState(0);
    const [length, setLength] = useState(0);
    const [queryParams, setQueryParams] = useState({
        start: 0, end: 10, search: '', page: 1,
        statusFilter: '', subscriptionFilter: '', settlementTypeFilter: '', accountTypeFilter: '',
        creationDateFrom: '', creationDateTo: '', paymentDateFrom: '', paymentDateTo: ''
    });
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [pendingFilters, setPendingFilters] = useState({
        statusFilter: '', subscriptionFilter: '', settlementTypeFilter: '', accountTypeFilter: '',
        creationDateFrom: '', creationDateTo: '', paymentDateFrom: '', paymentDateTo: ''
    });
    const { t, i18n, ready } = useTranslation();

    useEffect(() => {
        async function fetchData() {
            await refreshItems();
        }
        fetchData();
    }, []);

    const handleClose = () => {
        if (props.setIsOpenUsers) props.setIsOpenUsers(false);
    };

    const removeUser = async () => {
        await apiUsers.remove({id: id});
        await refreshItems();
        setOpenDelete(false);
    };

    const showRemove = (id) => {
        setIdValue(id);
        setOpenDelete(true);
    };

    const showGrantSubscription = (id) => {
        setGrantUserId(id);
        setGrantIsYear(false);
        setOpenGrant(true);
    };

    const grantSubscription = async () => {
        setIsGrantLoading(true);
        await apiUsers.grantSubscription({ userId: grantUserId, isYear: grantIsYear });
        await refreshItems();
        setIsGrantLoading(false);
        setOpenGrant(false);
    };

    const setUser = (id,email,firstName, lastName, company, city) => {
        setIdValue(id);
        setValue("email",email);
        setValue("firstName",firstName);
        setValue("lastName",lastName);
        setValue("company",company);
        setValue("city",city);
    }

    const cancel = () => {
        setValue("email","");
        setValue("firstName","");
        setValue("lastName","");
        setValue("company","");
        setValue("city","");
    }

    const sortColumns = ['id', 'email', 'firstName', 'lastName', 'company', 'nip', 'creationDate', 'postalCode', 'city', 'street',
        'number', 'status', 'subscription', 'paymentDate', 'paymentAmount', 'settlementType', 'referenceCode', 'newsletter', 'documents', 'isLocal', 'lastLoginDate', 'accountType'];

    const setSort = async (index) => {
        let tempSortName = sortColumns[index];
        if(sortOrder!=='desc')
        {
            setSortOrder('desc');
            tempSortName = '-' + tempSortName;
        }
        else
        {
            setSortOrder('asc');
        }
        setSortName(tempSortName);
        setSortIndex(index);
        let query = { ...queryParams, start: 0, end: 10, order: tempSortName };
        setQueryParams(query);
        await refreshItems(query);
    }

    const refreshItems = async (params = queryParams) => {
        let users = await apiUsers.users(params);
        if(users!==null)
        {
            setItems(users.items || []);
            setLength(users.length || 0);
        }
    }

    const search = async(query) => {
        setPage(0);
        const params = { ...queryParams, start: 0, end: 10, page: 1, search: query };
        setQueryParams(params);
        await refreshItems(params);
    }

    const activeFilterCount = ['statusFilter','subscriptionFilter','settlementTypeFilter',
        'accountTypeFilter','creationDateFrom','creationDateTo','paymentDateFrom','paymentDateTo']
        .filter(k => queryParams[k] !== '').length;

    const openFilters = (e) => {
        setPendingFilters({
            statusFilter: queryParams.statusFilter,
            subscriptionFilter: queryParams.subscriptionFilter,
            settlementTypeFilter: queryParams.settlementTypeFilter,
            accountTypeFilter: queryParams.accountTypeFilter,
            creationDateFrom: queryParams.creationDateFrom,
            creationDateTo: queryParams.creationDateTo,
            paymentDateFrom: queryParams.paymentDateFrom,
            paymentDateTo: queryParams.paymentDateTo,
        });
        setFilterAnchorEl(e.currentTarget);
    };

    const closeFilters = () => setFilterAnchorEl(null);

    const applyFilters = async () => {
        setPage(0);
        const params = { ...queryParams, ...pendingFilters, start: 0, end: 10, page: 1 };
        setQueryParams(params);
        await refreshItems(params);
        closeFilters();
    };

    const clearFilters = async () => {
        const cleared = {
            statusFilter: '', subscriptionFilter: '', settlementTypeFilter: '', accountTypeFilter: '',
            creationDateFrom: '', creationDateTo: '', paymentDateFrom: '', paymentDateTo: ''
        };
        setPendingFilters(cleared);
        setPage(0);
        const params = { ...queryParams, ...cleared, start: 0, end: 10, page: 1 };
        setQueryParams(params);
        await refreshItems(params);
        closeFilters();
    };

    const handleChangePage = async (event, newPage) => {
        setPage(newPage);
        let query = { ...queryParams, start: newPage * 10, end: (newPage + 1) * 10 };
        setQueryParams(query);
        await refreshItems(query);
    };

    const pageLeft = async () => {
        let newPage=0;
        if(page>1)
            newPage=page-1;
        setPage(newPage);
        let query = { ...queryParams, start: newPage * 10, end: (newPage + 1) * 10 };
        setQueryParams(query);
        await refreshItems(query);
    };

    const pageRight = async () => {
        let newPage = 1;
        if(page<=parseInt(length/10))
            newPage=page+1;
        setPage(newPage);
        let query = { ...queryParams, start: newPage * 10, end: (newPage + 1) * 10 };
        setQueryParams(query);
        await refreshItems(query);
    };

    const tableContent = (
        <div style={{width: '100%'}}>
            <Grid container alignItems="flex-end">
                <Grid item xs>
                    <h2 className="table-title">{t("users_text1")}</h2>
                </Grid>
                <Grid item className="right-element" style={{ marginTop: '25px', marginRight: '12px' }}>
                    <a className={`button filter-btn ${activeFilterCount > 0 ? 'button-blue' : 'button-filter'}`}
                        onClick={openFilters}>
                        {t("users.filters.button")}
                        {activeFilterCount > 0 && ` (${activeFilterCount})`}
                    </a>
                </Grid>
                <Grid item style={{width: "300px"}} className="right-element search-field">
                    <i className="search"></i>
                    <TextField autoComplete='off' placeholder={t("index_text12")} className='search-input' onChange={(e)=>search(e.target.value)}/>
                </Grid>
            </Grid>
            <Popover
                open={Boolean(filterAnchorEl)}
                anchorEl={filterAnchorEl}
                onClose={closeFilters}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{ className: 'filter-popover-paper' }}
            >
                <div className="filter-popover">
                    <Grid container spacing={1.5} alignItems="center">
                        <Grid item>
                            <FormControl size="small" sx={{ minWidth: 150 }}>
                                <Select value={pendingFilters.statusFilter} displayEmpty
                                    renderValue={(val) => (
                                        <span style={{ color: val === '' ? '#929292' : '#373737' }}>
                                            {val === '' ? t("users.filters.status") : val === 'Aktywny' ? t("users.filters.status_active") : t("users.filters.status_inactive")}
                                        </span>
                                    )}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, statusFilter: e.target.value }))}>
                                    <MenuItem value="">{t("users.filters.all")}</MenuItem>
                                    <MenuItem value="Aktywny">{t("users.filters.status_active")}</MenuItem>
                                    <MenuItem value="Nieaktywny">{t("users.filters.status_inactive")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl size="small" sx={{ minWidth: 170 }}>
                                <Select value={pendingFilters.subscriptionFilter} displayEmpty
                                    renderValue={(val) => (
                                        <span style={{ color: val === '' ? '#929292' : '#373737' }}>
                                            {val === '' ? t("users.filters.subscription") : val === 'Aktywna' ? t("users.filters.subscription_active") : t("users.filters.subscription_inactive")}
                                        </span>
                                    )}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, subscriptionFilter: e.target.value }))}>
                                    <MenuItem value="">{t("users.filters.all")}</MenuItem>
                                    <MenuItem value="Aktywna">{t("users.filters.subscription_active")}</MenuItem>
                                    <MenuItem value="Nieaktywna">{t("users.filters.subscription_inactive")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl size="small" sx={{ minWidth: 190 }}>
                                <Select value={pendingFilters.settlementTypeFilter} displayEmpty
                                    renderValue={(val) => (
                                        <span style={{ color: val === '' ? '#929292' : '#373737' }}>
                                            {val === '' ? t("users.filters.settlement_type") : val === 'Roczne' ? t("users.filters.settlement_annual") : t("users.filters.settlement_monthly")}
                                        </span>
                                    )}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, settlementTypeFilter: e.target.value }))}>
                                    <MenuItem value="">{t("users.filters.all")}</MenuItem>
                                    <MenuItem value="Roczne">{t("users.filters.settlement_annual")}</MenuItem>
                                    <MenuItem value="Miesięczne">{t("users.filters.settlement_monthly")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl size="small" sx={{ minWidth: 210 }}>
                                <Select value={pendingFilters.accountTypeFilter} displayEmpty
                                    renderValue={(val) => (
                                        <span style={{ color: val === '' ? '#929292' : '#373737' }}>
                                            {val === '' ? t("users.filters.account_type") : val === 'Odbiorca dokumentu' ? t("users.filters.account_type_recipient") : t("users.filters.account_type_form")}
                                        </span>
                                    )}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, accountTypeFilter: e.target.value }))}>
                                    <MenuItem value="">{t("users.filters.all")}</MenuItem>
                                    <MenuItem value="Odbiorca dokumentu">{t("users.filters.account_type_recipient")}</MenuItem>
                                    <MenuItem value="Formularz rejestracyjny">{t("users.filters.account_type_form")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div style={{ marginTop: '28px' }}>
                        <Grid container spacing={1.5} alignItems="center">
                            <Grid item>
                                <TextField size="small" type="date" label={t("users.filters.creation_date_from")}
                                    InputLabelProps={{ shrink: true }} value={pendingFilters.creationDateFrom}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, creationDateFrom: e.target.value }))} />
                            </Grid>
                            <Grid item>
                                <TextField size="small" type="date" label={t("users.filters.creation_date_to")}
                                    InputLabelProps={{ shrink: true }} value={pendingFilters.creationDateTo}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, creationDateTo: e.target.value }))} />
                            </Grid>
                            <Grid item>
                                <TextField size="small" type="date" label={t("users.filters.payment_date_from")}
                                    InputLabelProps={{ shrink: true }} value={pendingFilters.paymentDateFrom}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, paymentDateFrom: e.target.value }))} />
                            </Grid>
                            <Grid item>
                                <TextField size="small" type="date" label={t("users.filters.payment_date_to")}
                                    InputLabelProps={{ shrink: true }} value={pendingFilters.paymentDateTo}
                                    onChange={(e) => setPendingFilters(f => ({ ...f, paymentDateTo: e.target.value }))} />
                            </Grid>
                        </Grid>
                    </div>
                    <div className="filter-popover__actions">
                        <a className="button button-cancel" onClick={clearFilters}>{t("users.filters.clear")}</a>
                        <a className="button" onClick={applyFilters}>{t("users.filters.apply")}</a>
                    </div>
                </div>
            </Popover>
            <Grid container className="padding-body">
            <Grid item xs={12}>
            <TableContainer className="document-list user user-list">
                <Table aria-labelledby="tableTitle" aria-label="enhanced table">
                    <TableHead>
                        <TableRow>
                            <SortableTableCell index={0} label={t("users.table.columns.id")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={1} label={t("users.table.columns.email")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={2} label={t("users.table.columns.first_name")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={3} label={t("users.table.columns.last_name")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={4} label={t("users.table.columns.company")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={5} label={t("users.table.columns.nip")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={6} label={t("users.table.columns.creation_date")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={7} label={t("users.table.columns.postal_code")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={8} label={t("users.table.columns.city")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={9} label={t("users.table.columns.street")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={10} label={t("users.table.columns.number")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={11} label={t("users.table.columns.status")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={12} label={t("users.table.columns.subscription")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={13} label={t("users.table.columns.payment_date")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={14} label={t("users.table.columns.payment_amount")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={15} label={t("users.table.columns.settlement_type")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={16} label={t("users.table.columns.reference_code")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={17} label={t("users.table.columns.newsletter")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={18} label={t("users.table.columns.documents")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={19} label={t("users.table.columns.is_local")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={20} label={t("users.table.columns.last_login_date")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <SortableTableCell index={21} label={t("users.table.columns.account_type")} sortIndex={sortIndex} sortOrder={sortOrder} hover={hover} setSort={setSort} setHover={setHover}/>
                            <TableCell align="left" style={{width: 90, minWidth: 90}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.map((row, index) => {
                            return(
                            <TableRow key={index}>
                                <TableCell align="left">{row.Id}</TableCell>
                                <TableCell align="left">{row.Email}</TableCell>
                                <TableCell align="left">{row.FirstName}</TableCell>
                                <TableCell align="left">{row.LastName}</TableCell>
                                <TableCell align="left">{row.Company}</TableCell>
                                <TableCell align="left">{row.NIP}</TableCell>
                                <TableCell align="left">{row.CreationDate}</TableCell>
                                <TableCell align="left">{row.PostalCode}</TableCell>
                                <TableCell align="left">{row.City}</TableCell>
                                <TableCell align="left">{row.Street}</TableCell>
                                <TableCell align="left">{row.Number}</TableCell>
                                <TableCell align="left">{row.Status}</TableCell>
                                <TableCell align="left">{row.Subscription}</TableCell>
                                <TableCell align="left">{row.PaymentDate}</TableCell>
                                <TableCell align="left">{row.PaymentAmount}</TableCell>
                                <TableCell align="left">{row.SettlementType}</TableCell>
                                <TableCell align="left">{row.ReferenceCode}</TableCell>
                                <TableCell align="left">{row.Newsletter}</TableCell>
                                <TableCell align="left">{row.Documents}</TableCell>
                                <TableCell align="left">{row.IsLocal}</TableCell>
                                <TableCell align="left">{row.LastLoginDate}</TableCell>
                                <TableCell align="left">{row.AccountType}</TableCell>
                                <TableCell align="left" style={{width: 90, minWidth: 90, whiteSpace: "nowrap"}}>
                                    <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                                        <a className="grant-subscription" title={t("users.table.grant_subscription")} onClick={()=>showGrantSubscription(row.Id)} style={{float: "none", marginTop: 0}}></a>
                                        <a className="x" onClick={()=>showRemove(row.Id)} style={{float: "none", marginTop: 0, position: "relative", top: -1}}></a>
                                    </div>
                                </TableCell>
                            </TableRow>);
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination component="div" count={length} rowsPerPage={10} page={page} labelRowsPerPage="" onPageChange={handleChangePage}/>
            </Grid>
            </Grid>
        </div>
    );

    return (
        <div className='users' style={props.inline ? {width: '100%'} : {}}>
            {props.inline
                ? tableContent
                : (
                    <Dialog open={props.isOpenUsers} onClose={handleClose} style={{padding:"20px"}} maxWidth="lg" fullWidth>
                        <div className='dialog-user'>
                            <DialogTitle>
                                {t("users_text1")}
                            </DialogTitle>
                            <DialogContent>
                            <DialogContentText>
                                <a className="x dialog-close" onClick={handleClose}></a>
                                {tableContent}
                            </DialogContentText>
                            </DialogContent>
                            <DialogActions >
                                <Grid container spacing={2} className="right-side action-margin">
                                    <a className="button button-cancel" fullWidth onClick={()=>handleClose()}>{t("users_text20")}</a>&nbsp;&nbsp;
                                </Grid>
                            </DialogActions>
                        </div>
                    </Dialog>
                )
            }
            <Dialog open={openDelete} onClose={()=>setOpenDelete(false)} style={{padding:"10px"}}>
                <DialogContent>
                    <DialogContentText>
                        Czy na pewno chcesz usunąć użytkownika?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <a onClick={()=>setOpenDelete(false)} className="button button-cancel" fullWidth><i className="back"></i>Nie</a>
                        </Grid>
                        <Grid item xs>
                            <Button className="button full-width" onClick={()=>removeUser()}>
                                {isLoading &&
                                    <span className="loader"></span>
                                }
                                {!isLoading &&
                                    <span>Tak</span>
                                }
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog open={openGrant} onClose={()=>setOpenGrant(false)} PaperProps={{style:{width: 400, padding: "10px"}}}>
                <DialogTitle className="subscription-dialog-title" style={{paddingBottom: 4}}>
                    {t("users.grant_subscription.title")}
                </DialogTitle>
                <DialogContent style={{paddingTop: 8}}>
                    <DialogContentText className="subscription-dialog-description" style={{marginBottom: 20}}>
                        {t("users.grant_subscription.description")}
                    </DialogContentText>
                    <FormControl fullWidth style={{marginBottom: 8}}>
                        <Select value={grantIsYear} onChange={(e)=>setGrantIsYear(e.target.value)}>
                            <MenuItem value={false}>{t("users.grant_subscription.month")}</MenuItem>
                            <MenuItem value={true}>{t("users.grant_subscription.year")}</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{padding: "16px 24px 24px"}}>
                    <div className="subscription-dialog-actions">
                        <button type="button" onClick={()=>setOpenGrant(false)} className="subscription-dialog-btn subscription-dialog-btn-cancel">
                            {t("users_text20")}
                        </button>
                        <button type="button" onClick={()=>grantSubscription()} className="subscription-dialog-btn subscription-dialog-btn-confirm">
                            {isGrantLoading &&
                                <span className="loader"></span>
                            }
                            {!isGrantLoading &&
                                <span>{t("users.grant_subscription.confirm")}</span>
                            }
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default UsersComponent;
